export default __webpack_public_path__ + "static/media/background-inte.31a2a365.png";